import {Component, OnInit} from '@angular/core';
import {CpProvisionTypeMatrixBaseComponent} from '../base/cp-provision-type-matrix-base.component';

/**
 * Full view of the Provisionsmatrix OBC (`uiMode = 'full'`).
 *
 * Shape of `cp-provision-contract-agent-full.component.ts`: inherits the `navigationItems` from
 * {@link CpProvisionTypeMatrixBaseComponent} and renders the ONE shared detail component in its
 * wide variant (`[compact]="false"`). It holds no business logic and no form HTML of its own.
 */
@Component({
    selector: 'cp-provision-type-matrix-full',
    templateUrl: './cp-provision-type-matrix-full.component.html',
    styleUrls: ['./cp-provision-type-matrix-full.component.scss'],
    standalone: false
})
export class CpProvisionTypeMatrixFullComponent extends CpProvisionTypeMatrixBaseComponent
    implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }

}
